import { configureStore } from '@reduxjs/toolkit';
import locationReducer from './slices/locationSlice';
import postReducer from './slices/postSlice';

export const store = configureStore({
  reducer: {
    counter: locationReducer,
    posts:postReducer
  },
});

export default store;
